
import React, { useState } from "react";
import "./CyberArkEPM​.css";
import MenuNavbar from "../../MenuNavbar";
import Floaticons from "../../Floaticons";
import Tabs from "@mui/material/Tabs";
import PropTypes from "prop-types";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IdentiyAccessManagement from "../IdentityManagement/IdentityandAccessManagement";
import InfrastructureSecurity from "../InfrastructureSecurity/InfrastructureSecurity";
import PlatformSecurity from "../PlatformSecurity/PlatformSecurity";
import CloudSecurity from "../CloudSecurity/CloudSecurity";
import Link from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import { Breadcrumbs } from "@material-ui/core";

import TopicData from "../../Data/CyberArkEPMdata.json";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 4 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function CyberarkEPM() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  const [showMore, setShowMore] = useState();

  return (
    <>
      <div className="banner-container">
        <img
          src="images/SecuritySchools/SailPoint/school-banner.png"
          alt="banner"
          className="banner-img"
        />
        <div className="breadcrumbs-container">
          <Breadcrumbs separator=">" color="#fff">
            <Link
              underline="hover"
              sx={{ display: "flex", alignItems: "center" }}
              color="#fff"
              href="/"
            >
              <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            </Link>
            ,
            <Link
              underline="hover"
              key="2"
              color="#fff"
              href="/securityLearningFramework"
            // onClick={handleClick}
            >
              Security Learning Framework
            </Link>
            ,
            <Typography key="3" color="#fff">
              Security Schools
            </Typography>
            ,
          </Breadcrumbs>
        </div>
        <div className="banner-content">
          <h1>Security Schools</h1>
          <i>
            Lorem ipsum is a dummy text of the printing and typesetting industry
          </i>
        </div>
        <MenuNavbar />
      </div>
      <Floaticons />
      <div className="breadcrumbLinks">
        <Breadcrumbs separator=">" aria-label="breadcrumb">
          <a className="menu_title" href="/securitySchools">
            <img src="/images/SecuritySchools/Back-button.png" />
            Security Schools and Bootcamps
          </a>
          {value === 0 ? (
            <a className="menu_title" href="/securitySchools#I&DInitiatives">
              Identity & Access Management
            </a>
          ) : (
            ""
          )}
          {value === 1 ? (
            <a
              className="menu_title"
              href="/securitySchools#InfrastructureSecurity"
            >
              Infrastructure Security
            </a>
          ) : (
            ""
          )}
          {value === 2 ? (
            <a className="menu_title" href="/securitySchools#platformsecurity">
              Platform Security
            </a>
          ) : (
            ""
          )}
          {value === 3 ? (
            <a className="menu_title" href="/securitySchools#cloudsecurity">
              Cloud Security
            </a>
          ) : (
            ""
          )}
          <a className="menu_title" href="">
            CyberArk EPM Admin
          </a>
        </Breadcrumbs>
      </div>
      <div className="main-container" id="Cyberark-EPM">
        <Box className="boxStyles">
          <Box
            sx={{ borderBottom: 0, borderColor: "divider" }}
            className="tabMenuWrap"
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              centered
            >
              <Tab
                label="Identity & Access Management​"
                {...a11yProps(0)}
                className="tabStyles"
              />
              <Tab
                label="Infrastructure Security"
                {...a11yProps(1)}
                className="tabStyles"
              />
              <Tab
                label="Platform Security"
                {...a11yProps(2)}
                className="tabStyles"
              />
              <Tab
                label="Cloud Security"
                {...a11yProps(3)}
                className="tabStyles"
              // href='https://atci.lkm.delivery.accenture.com/ProfessionalSkills/' target='_blank'
              />
            </Tabs>
          </Box>
          <TabPanel className="tabPanelWrap" value={value} index={0}>
            <div id="">
              <div className="Oracle-AboutWrapp">
                <div className="leftImage">
                  <img
                    src="images/SecuritySchools/CyberARK-EPM/About-cyberARK-EPM.png"
                    alt=""
                    className="img-responsive"
                  />
                </div>
                <div className="rightContent">
                  <h2 className="SP-AboutHeading">About the CyberArk EPM Admin</h2>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s,
                  </p>
                </div>
              </div>
              <div className="ObjectiveSection">
                <div className="Border-Outer ">
                  <div className="ObjectiveRow">
                    <div className="box1">
                      <img src="images/SecuritySchools/CyberARK-EPM/Traning-Objective.png" />
                      <h3 className="ObjectiveHead">Training Objective</h3>
                      <p>
                        Introduces participants to EPM solutions and provides
                        hands-on experience in leveraging various EPM features
                        for endpoint protection of an Enterprise.
                      </p>
                    </div>
                    <div className="box2">
                      <span className="borderLeft"></span>
                      <img src="images/SecuritySchools/CyberARK-EPM/Audience.png" />
                      <h3 className="ObjectiveHead">Audience</h3>
                      <p>CyberArk PAM Practitioners​</p>
                      <span className="borderRight"></span>
                    </div>
                    <div className="box3">
                      <img src="images/SecuritySchools/CyberARK-EPM/Case-study.png" />
                      <h3 className="ObjectiveHead">Case Study</h3>
                      <p>
                        Participants prepare the presentation for a real-time
                        case study of securing an enterprise, leveraging the
                        skill gathered during the training.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row1-bottom-section">
                <div>
                  <p className="border-Heading">
                    <span>Total Duration: 45 hours​</span>
                    <img
                      src="images/SecuritySchools/SecurityPlatforms/arrow.png"
                      alt=""
                    />
                  </p>
                  <p>
                    <span className="bold">Training model: </span> <br></br>
                    <span className="light">
                    VILT+ Self-paced+Hands-On+assessment​
                    </span>

                  </p>
                </div>
              </div>

              <div className="topicIn-Focus-Wrapper">
                <div className="FocusInnerContainer">
                  <h2 className="infocusHead">Topics in Focus</h2>
                  <div className="cardRow">


                    {/* Card 1 */}
                    {
                      TopicData.Topics.map((item) => {
                        return (
                          <div className="Infocus-Cards" id={"card" + item.id}>
                            <h3>{item.TopicHeader}</h3>
                            <div className="InfocusList-wrapper">
                              <ul>
                                {
                                  item.list.slice(0, 3).map((listDetail) => {
                                    return (
                                      <li>
                                        <a href={listDetail.url}>{listDetail.Text}</a>
                                      </li>
                                    );
                                  })
                                }
                                {
                                  showMore==item.id &&
                                  item.list.slice(3).map((listDetail) => {
                                    return (
                                      <li>
                                        <a href={listDetail.url}>{listDetail.Text}</a>
                                      </li>
                                    );
                                  })
                                }
                                {
                                  showMore!==item.id ? <p className="downArrow" onClick={() => setShowMore(item.id)} ><img src="images/SecuritySchools/CyberARK-EPM/Down-arrow.png" alt="down-arrow"/>
                                    </p>:<p className="upArrow" onClick={() => setShowMore()}>
                                    <img src="images/SecuritySchools/CyberARK-EPM/Up-arrow.png" alt="up-arrow"  /></p>
                                }
                              </ul>
                            </div>
                            <span className="bottomBorder-purple"></span>

                          </div>
                        );
                      })
                    }
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={1}>
            <InfrastructureSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={2}>
            <PlatformSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={3}>
            <CloudSecurity />
          </TabPanel>
        </Box>
      </div>
    </>
  );
}

export default CyberarkEPM;

